import { motion } from "framer-motion";
import { ClipImage, SectionHead, Reveal } from "./Reveal";
import { EASE, scrollToId } from "@/lib/site";

const ITEMS = [
  ["Cucine", "Cucine su misura e componibili, con piani in marmo, quarzo o ceramica ed elettrodomestici da incasso."],
  ["Mobili su misura", "Librerie, pareti attrezzate, boiserie e mobili living progettati sugli spazi della tua casa."],
  ["Armadi e cabine armadio", "Armadi a muro, cabine armadio e ante scorrevoli con finiture coordinate alle porte."],
  ["Mobili bagno", "Mobili sospesi, top in pietra, specchi contenitori e accessori abbinati alla rubinetteria."],
  ["Complementi d'arredo", "Illuminazione, tavoli, sedute e tessili per consegnare una casa completa e pronta da vivere."],
];

export const Furniture = () => (
  <section id="arredamento" data-testid="furniture-section" className="relative bg-[#ece5d8] text-[#1c1915] py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16 lg:gap-10">
      <div className="lg:col-span-6">
        <SectionHead light label="Arredamento" title={<>Non solo muri: <em className="italic text-[#7d5a12]">arrediamo</em> la tua casa.</>}>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#3b352d] max-w-xl">
            A fine cantiere non resti con stanze vuote. Progettiamo, forniamo e montiamo cucine e arredi coordinati con
            pavimenti, rivestimenti e serramenti, sempre con lo stesso interlocutore.
          </p>
        </SectionHead>
        <ul className="mt-14 border-t border-[#1c1915]/15">
          {ITEMS.map(([t, d], i) => (
            <motion.li key={t} data-testid={`furniture-item-${i}`}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, delay: i * 0.06, ease: EASE }}
              className="group grid grid-cols-12 gap-4 py-6 border-b border-[#1c1915]/15">
              <span className="col-span-2 sm:col-span-1 font-display italic text-lg text-[#7d5a12]">0{i + 1}</span>
              <div className="col-span-10 sm:col-span-11">
                <h3 className="font-display text-2xl md:text-3xl group-hover:translate-x-2 transition-transform duration-500">{t}</h3>
                <p className="mt-2 text-sm md:text-base text-[#4a443a] leading-relaxed">{d}</p>
              </div>
            </motion.li>
          ))}
        </ul>
        <Reveal delay={0.1} className="mt-10">
          <button data-testid="furniture-cta" onClick={() => scrollToId("contatti")}
            className="bg-[#1c1915] text-[#f4f1ea] px-8 py-4 text-xs tracking-[0.25em] uppercase hover:bg-[#7d5a12] transition-colors duration-500">
            Progettiamo il tuo arredo
          </button>
        </Reveal>
      </div>
      <div className="lg:col-span-5 lg:col-start-8 grid grid-cols-2 gap-4 content-start lg:sticky lg:top-28 self-start">
        <ClipImage src="/img/cucina.jpg" alt="Cucina su misura con isola in marmo" testid="furniture-image-0" className="col-span-2 aspect-[4/3]" />
        <ClipImage src="/img/armadio.jpg" alt="Cabina armadio su misura" testid="furniture-image-1" className="aspect-[3/4]" />
        <ClipImage src="/img/arredo.jpg" alt="Zona pranzo arredata" testid="furniture-image-2" className="aspect-[3/4] lg:mt-16" />
      </div>
    </div>
  </section>
);
